<!-- =========================================================================================
    File Name: CardBasic.vue
    Description: Basic Cards
    ----------------------------------------------------------------------------------------
    Item Name: BCC Pubs
      Author: SweetAs
    Author URL: http://sweetas.xyz
========================================================================================== -->


<template>      
    <div class="mt-3">  
        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <vs-input icon="search" placeholder="Search" v-model="pagSearch" @keyup="tableSearch" class="w-1/2 round-border"/>
            </div>
            <div class="vx-col w-1/2">
                <vs-pagination :total="pagPages" v-model="pagCurrentX"></vs-pagination>
            </div>
        </div>
        <vs-table
            multiple 
            v-model="productsSelected" 
            :onlyClickCheckbox="true"
            @selected="handleProductSelected($event)"
            max-items="25"   
            :data="st_data">
            <template slot="header">    
                <vs-button v-if="dataTableChanged" class="mr-3 mt-5"  @click="updateInfoPointProductList">Update</vs-button>
            </template>  
            <template slot="pagination">    
                <vs-pagination v-model="productListMintsoft" :length="productListMintsoft.length/25" />  
            </template>
            <template slot="thead">
                <vs-th sort-key="SKU">SKU</vs-th>
                <vs-th sort-key="Name">Name</vs-th>
                <vs-th sort-key="ImageURL">Image</vs-th>
                <!-- <vs-th sort-key="limit">Limit</vs-th> -->
                <vs-th sort-key="LowStockAlertLevel">Stock Alert</vs-th>
            </template>
            <template slot-scope="{data}">
                <vs-tr  :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].SKU">
                    {{ data[indextr].SKU }}
                </vs-td>
                <vs-td :data="data[indextr].Name">
                    {{ data[indextr].Name }}
                </vs-td>
                <vs-td>
                    <img v-if="data[indextr].ImageURL.indexOf('http') >= 0" :src="data[indextr].ImageURL"  class="product-img"/>
                    <img v-if="data[indextr].ImageURL ==''" src="@/assets/images/pages/no-image.png" class="product-img-stock"/>
                    <img v-if="data[indextr].ImageURL!='' && data[indextr].ImageURL.indexOf('http') < 0" :src="require(`@/assets/images/bcc/${data[indextr].ImageURL}`)" class="product-img"/>
                </vs-td>
                <vs-td :data="data[indextr].LowStockAlertLevel">
                    <vs-chip color="warning">
                        {{ data[indextr].LowStockAlertLevel }}
                    </vs-chip>
                </vs-td>
                </vs-tr>
            </template>
        </vs-table>
        <vs-pagination :total="pagPages" v-model="pagCurrentX"></vs-pagination>
    </div>          
</template>
<script>
export default{
  components: {  
  },
  data () {
    return {
      pagPages:0,
      pagPageSize: 25,
      pagCurrentX: 1,
      pagSearch:'',     
      dataChanged:false,
      dataTableChanged:false,      
      initDetails:'',
      productsSelected:[],
      productListMintsoft:[],         
    }
  },
  computed: {
    st_data_raw () {
      let l = this.productListMintsoft
      if (this.pagSearch.length > 0) {
        const r = this.pagSearch.toUpperCase() 
        l = l.filter(x => {    
          return (x.SKU.toUpperCase().indexOf(r) > -1 || x.Name.toUpperCase().indexOf(r) > -1)          
        })
      }
      return l
    },   
    st_data () {      
      // pagination st_data_raw
      return this.st_data_raw.filter((x, index) => {
        const start = (this.pagCurrentX - 1) * this.pagPageSize
        const end = this.pagCurrentX * this.pagPageSize        
        if (index >= start && index < end) return true
      })   
    },
    st_state: {
      get () { 
        return this.$store.state.dataList.details 
      }
    },
  },
  mounted () {},
   methods: {
    calculatePagination (y) {      
      
      const g = y === 0 ? this.productListMintsoft : this.st_data_raw
      this.pagPages = parseInt((g.length === 0 ? 1 : g.length) / this.pagPageSize) + 1
    },
    tableSearch () { 
      this.pagCurrentX = 1
      const r = this.pagSearch.length > 0 ? 1 : 0 
      this.calculatePagination(r)
    },
    getMintsoftProducts () {  
      this.$vs.loading()    
      this.$store.dispatch('dataList/getMintsoftProducts').then(d => {
        const g = d.data
        for (let i = 0; i < g.length; i++) {
          // set default product limit to zero
          g[i].Limit = 0
        }     
        this.productListMintsoft = g 
        this.calculatePagination(0)

        this.getProducts(1)
        this.$vs.loading.close()
      })
    },
    getProducts (r) {
      this.$vs.loading()
      const payload = {IpId:  this.$route.params.id, StockAlert: r}     
      this.$store.dispatch('dataList/getProducts', payload).then(() => {
        //this.productsSelected = this.$store.state.dataList.products 
        const k = []        
        const f = this.productListMintsoft 
        this.$store.state.dataList.products.forEach(x => {
          if (x !== undefined) { 
            f.forEach(p => { 
              if (p.ID === x.id) { 
                p.ImageURL = x.image
                p.Limit = x.limit
                k.push(p)
              }
            })
          }
        })
                
        this.productsSelected = k
        this.$vs.loading.close()
      })
    },
    handleProductSelected (tr) {
      this.dataTableChanged = true
      this.$vs.notify({
        title: `SKU: ${tr.SKU}`,
        text: `Name: ${tr.Name}`
      })
    }, 
    updateInfoPointProductList () {  
      this.$vs.loading() 
      
      const tPaginationAll = []
      this.st_data.forEach(x => tPaginationAll.push({Id: x.ID.toString()}))

      const tPaginationSel = []
      tPaginationAll.forEach(n => {
        this.productsSelected.forEach(m => {
          if (n.Id === String(m.ID)) {
            tPaginationSel.push({Id: m.ID.toString(), Limit: m.Limit.toString()}) 
          }
        })
      })
      
      const _details = this.st_state
      this.productsSelected = []
      const payload = { refid: this.sw_refid, selected: JSON.stringify(tPaginationSel), products: JSON.stringify(tPaginationAll)}
      this.$store.dispatch('dataList/updateInfoPointProductList', payload).then(() => {
        // reload products
        this.getProducts(0)
        this.$swal({
          title: 'Updated',
          text: `${_details.company} has been updated`,
          icon: 'success',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Close'
        })
        this.$vs.loading.close()
      }) 
    }
  },
  created () {  
    this.$vs.loading()
    this.getMintsoftProducts()
  }
}
</script>
<style lang="scss">
.round-border .vs-inputx{
  border: 0px!important; 
}
.vs-input--input:focus{
  border: 1px solid rgba(0, 0, 0, 0.1)!important;
  height: 38px !important;
  width: 101%;
  border-radius: 20px !important;
}

.round-border .input-span-placeholder{
  border-radius:40px!important;
  border: 1px solid rgba(0, 0, 0, 0.1);
}
.round-border .vs-icon{
  padding-top: 4px;
}
.product-img {
  max-height: 64px!important;
  width: 90px!important;
}
.product-img-stock{
  height: 64px!important;
}
.content-tr-expand{    justify-content: flex-end!important;}
.tr-expand td .tr-expand--close {background-color:inherit!important;}
.vs-con-table .empty {
     display: none!important;
}
</style>

